import { render } from "./spriteList.vue?vue&type=template&id=d637ee46&scoped=true&lang=pug"
import script from "./spriteList.vue?vue&type=script&setup=true&lang=js"
export * from "./spriteList.vue?vue&type=script&setup=true&lang=js"

import "./spriteList.vue?vue&type=style&index=0&id=d637ee46&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-d637ee46"

export default script